"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardItems = BoardItems;
const React = __importStar(require("react"));
const context_1 = require("../context");
const BoardItem_1 = require("./BoardItem");
function BoardItems({ render, dragDrop }) {
    const board = (0, context_1.useBoardState)();
    const pieceElements = [];
    for (const { id, x, y } of board.getAllPieces()) {
        if (!id) {
            continue;
        }
        const { item, draggable = false } = render(id, x, y);
        pieceElements.push(React.createElement(BoardItem_1.BoardItem, { key: id, id: id, x: x, y: y, draggable: Boolean(dragDrop && draggable) }, item));
    }
    return React.createElement(React.Fragment, null, pieceElements);
}
